module.exports = __webpack_public_path__ + "img/welcome.32fd686c.png";